<template>
  <div class="card card-913" data-slot="default">
    <div class="card__bg"
         :style="`background-image: url(${image})`"></div>
    <div class="card__content" >
      <slot>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorem ducimus eligendi inventore nam
          necessitatibus neque nulla veniam. Assumenda blanditiis, explicabo magni maiores minima omnis quaerat soluta
          sunt vitae voluptatibus. Mollitia.</p>
      </slot>
    </div>
  </div>
</template>

<script>

import mA from '../Tags/A'
import mImg from '../Tags/Img'
import {CardProps} from "./CardProps";

export default {
  name: "Card913",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps
  },
  mounted() {
    const cards = document.querySelectorAll(".card-913");

    cards.forEach(card => {
      card.addEventListener("mouseover", () => {
        cards.forEach(otherCard => {
          if (otherCard !== card) {
            otherCard.style.filter = "blur(5px)";
            otherCard.style.zIndex = "1";
          }
        });
      });

      card.addEventListener("mouseout", () => {
        cards.forEach(otherCard => {
          if (otherCard !== card) {
            otherCard.style.filter = "none";
            otherCard.style.zIndex = "0";
          }
        });
      });
    });
  }
}

</script>

<style scoped>
.card {
  width: 100%;
  border: none;
  position: relative;
  transition: all 0.5s ease-out;
  background: transparent;
}

.card__bg {
  position: relative;
  height: 50vh;
  min-width: 250px;
  background-size: cover;
  background-position: center center;
  border-radius: 1rem;
  overflow: hidden;
  transform: scale(1);
  transition: all 0.5s ease-out;
}

.card__bg::after {
  content: "";
  background-image: linear-gradient(360deg, black, transparent);
  height: 150px;
  bottom: 0;
  width: 100%;
  position: absolute;
}

.card__content {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
}

.card:hover {
  transform: scale(1.02);
  filter: drop-shadow(0px 0px 100px #acacac);
}


</style>